import * as React from 'react';

import { Viewer } from 'lib/api/recipients/types';
import { Button } from 'react-covideo-common';
import { NewModal } from 'lib/components/modal/NewModal';
import { ParagraphNormal } from 'lib/components/styles/typography';
import { Flex } from 'lib/components/styles/layout';
import { useTranslation } from 'react-i18next';

type Props = {
  handleModalClose: (block?: boolean) => void;
  recepient: Viewer;
};

export const ModalBlockRecepient = ({ handleModalClose, recepient }: Props) => {
  const { t } = useTranslation();
  return (
    <NewModal
      headerText={t('Block recipient?')}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose(false)}
      style={{
        content: {
          paddingLeft: '32px',
        },
      }}
    >
      <>
        <ParagraphNormal>
          {t('Are you sure you want to block the recipient (') +
            recepient.email +
            t(')?')}
        </ParagraphNormal>
        <Flex
          flexDirection='row'
          width='100%'
          gap='16px'
          justifyContent='flex-end'
          margin='32px 0 0 0'
        >
          <Button
            variant='secondary'
            text={t('No, Cancel')}
            onClick={() => handleModalClose(false)}
          />
          <Button
            variant='destructive'
            text={t('Yes, Block')}
            onClick={() => handleModalClose(true)}
          />
        </Flex>
      </>
    </NewModal>
  );
};
